/**
 * @author muhan
 * @desc 该类包含商品详情页的数据结构
 */
import { FileReader, FileWriter } from '@/platform'
import FileName from '../ComControl/FileName'
import Viewport from '../ComControl/Viewport'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'

class GoodDetailPageModel {
    // public DetailGraph: FileName = new FileName(FileName.DEF_TYPE, '菜单界面.png') // 详情页底板
    public DetailGraph: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城\\商城_弹窗背景.png' }) // 详情页底板
    public PreviewBackGraph: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城\\商城_商品背景图.png' }) // 预览图底板
    public PreviewBack_X: number = 0 // 预览图底板X坐标
    public PreviewBack_Y: number = 0 // 预览图底板Y坐标
    public PreviewBack_W: number = 0 // 预览图底板宽度
    public PreviewBack_H: number = 0 // 预览图底板高度
    public Preview_X: number = 0 // 预览图X坐标
    public Preview_Y: number = 0 // 预览图Y坐标
    public Preview_W: number = 0 // 预览图宽度
    public Preview_H: number = 0 // 预览图高度
    public GoodName_X: number = 0 // 商品名称X坐标
    public GoodName_Y: number = 0 // 商品名称Y坐标
    public FlowerTotal_X: number = 0 // 总价X坐标
    public FlowerTotal_Y: number = 0 // 总价Y坐标
    public Flower_X: number = 0 // 鲜花图片X坐标
    public Flower_Y: number = 0 // 鲜花图片Y坐标
    public GoodPrice_X: number = 0 // 商品价格X坐标
    public GoodPrice_Y: number = 0 // 商品价格Y坐标
    public GoodIntroView: Viewport = new Viewport() // 商品简介视窗信息
    public Ok_btn: AvgButtonIndex = new AvgButtonIndex() // 确认按钮
    public Cancel_btn: AvgButtonIndex = new AvgButtonIndex() // 取消按钮
    public Add_btn: AvgButtonIndex = new AvgButtonIndex() // 增加按钮
    public Minus_btn: AvgButtonIndex = new AvgButtonIndex() // 减少按钮
    public IsUseImageIndex: boolean = false // 购买数量是否使用图片索引
    public Index: number = 1 // 购买数量的索引
    public IndexImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) // 当前索引的图片
    public BuyCount_X: number = 0 // 购买数量X坐标
    public BuyCount_Y: number = 0 // 购买数量Y坐标
    public IsShowBuyCount: boolean = true // 是否显示购买数量
    public IsShowGoodName: boolean = true // 是否显示商品名称
    public IsShowGoodIntro: boolean = true // 是否显示商品简介
    public IsShowGoodImage: boolean = true // 是否显示商品图片

    readVersionedOui(reader: FileReader): void {
        this.DetailGraph.readVersionedOui(reader.readObj(reader.readInt()))
        this.PreviewBackGraph.readVersionedOui(reader.readObj(reader.readInt()))
        this.PreviewBack_X = reader.readInt()
        this.PreviewBack_Y = reader.readInt()
        this.PreviewBack_W = reader.readInt()
        this.PreviewBack_H = reader.readInt()
        this.Preview_X = reader.readInt()
        this.Preview_Y = reader.readInt()
        this.Preview_W = reader.readInt()
        this.Preview_H = reader.readInt()
        this.GoodName_X = reader.readInt()
        this.GoodName_Y = reader.readInt()
        this.FlowerTotal_X = reader.readInt()
        this.FlowerTotal_Y = reader.readInt()
        this.Flower_X = reader.readInt()
        this.Flower_Y = reader.readInt()
        this.GoodPrice_X = reader.readInt()
        this.GoodPrice_Y = reader.readInt()
        this.GoodIntroView.readVersionedOui(reader.readObj(reader.readInt()))
        this.Ok_btn.readVersionedOui(reader.readObj(reader.readInt()))
        this.Cancel_btn.readVersionedOui(reader.readObj(reader.readInt()))
        this.Minus_btn.readVersionedOui(reader.readObj(reader.readInt()))
        this.Add_btn.readVersionedOui(reader.readObj(reader.readInt()))
        this.IsUseImageIndex = Boolean(reader.readInt())
        this.Index = reader.readInt()
        this.IndexImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.BuyCount_X = reader.readInt()
        this.BuyCount_Y = reader.readInt()
        this.IsShowBuyCount = Boolean(reader.readInt())
        this.IsShowGoodName = Boolean(reader.readInt())
        this.IsShowGoodIntro = Boolean(reader.readInt())
        this.IsShowGoodImage = Boolean(reader.readInt())
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        this.DetailGraph.writeVersionedOui(writer)
        this.PreviewBackGraph.writeVersionedOui(writer)
        writer.writeInt(this.PreviewBack_X)
        writer.writeInt(this.PreviewBack_Y)
        writer.writeInt(this.PreviewBack_W)
        writer.writeInt(this.PreviewBack_H)
        writer.writeInt(this.Preview_X)
        writer.writeInt(this.Preview_Y)
        writer.writeInt(this.Preview_W)
        writer.writeInt(this.Preview_H)
        writer.writeInt(this.GoodName_X)
        writer.writeInt(this.GoodName_Y)
        writer.writeInt(this.FlowerTotal_X)
        writer.writeInt(this.FlowerTotal_Y)
        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        writer.writeInt(this.GoodPrice_X)
        writer.writeInt(this.GoodPrice_Y)
        this.GoodIntroView.writeVersionedOui(writer)
        this.Ok_btn.writeVersionedOui(writer)
        this.Cancel_btn.writeVersionedOui(writer)
        this.Minus_btn.writeVersionedOui(writer)
        this.Add_btn.writeVersionedOui(writer)
        writer.writeInt(this.IsUseImageIndex ? 1 : 0)
        writer.writeInt(this.Index)
        this.IndexImage.writeVersionedOui(writer)
        writer.writeInt(this.BuyCount_X)
        writer.writeInt(this.BuyCount_Y)
        writer.writeInt(this.IsShowBuyCount ? 1 : 0)
        writer.writeInt(this.IsShowGoodName ? 1 : 0)
        writer.writeInt(this.IsShowGoodIntro ? 1 : 0)
        writer.writeInt(this.IsShowGoodImage ? 1 : 0)

        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        writer.writerIntLength()

        this.DetailGraph.writeMallBin(writer)
        this.PreviewBackGraph.writeMallBin(writer)
        writer.writeInt(this.PreviewBack_X)
        writer.writeInt(this.PreviewBack_Y)
        writer.writeInt(this.PreviewBack_W)
        writer.writeInt(this.PreviewBack_H)
        writer.writeInt(this.Preview_X)
        writer.writeInt(this.Preview_Y)
        writer.writeInt(this.Preview_W)
        writer.writeInt(this.Preview_H)
        writer.writeInt(this.GoodName_X)
        writer.writeInt(this.GoodName_Y)
        writer.writeInt(this.FlowerTotal_X)
        writer.writeInt(this.FlowerTotal_Y)
        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        writer.writeInt(this.GoodPrice_X)
        writer.writeInt(this.GoodPrice_Y)
        this.GoodIntroView.writeMallBin(writer)
        this.Ok_btn.writeMallBin(writer)
        this.Cancel_btn.writeMallBin(writer)
        this.Minus_btn.writeMallBin(writer)
        this.Add_btn.writeMallBin(writer)
        writer.writeInt(this.IsUseImageIndex ? 1 : 0)
        writer.writeInt(this.Index)
        this.IndexImage.writeMallBin(writer)
        writer.writeInt(this.BuyCount_X)
        writer.writeInt(this.BuyCount_Y)
        writer.writeInt(this.IsShowBuyCount ? 1 : 0)
        writer.writeInt(this.IsShowGoodName ? 1 : 0)
        writer.writeInt(this.IsShowGoodIntro ? 1 : 0)
        writer.writeInt(this.IsShowGoodImage ? 1 : 0)

        writer.writerLength()
    }
}
export default GoodDetailPageModel
